import { StoreServiceCheckbox } from 'components/Pages/Stores/StoreServiceCheckbox';
import useTranslation from 'next-translate/useTranslation';
import { StoreServiceFiltersType, StoreServiceIconsType } from 'types/store';

type StoreServiceFiltersProps = {
    availableServices: StoreServiceFiltersType;
    serviceFilters: StoreServiceFiltersType;
    serviceIcons: StoreServiceIconsType;
    onServiceFilterChange: (service: keyof StoreServiceFiltersType, isChecked: boolean) => void;
};

export const StoreServiceFilters: FC<StoreServiceFiltersProps> = ({
    availableServices,
    serviceFilters,
    serviceIcons,
    onServiceFilterChange,
}) => {
    const { t } = useTranslation();

    if (!Object.values(availableServices).some(Boolean)) {
        return null;
    }

    return (
        <div className="mt-5 flex w-full flex-col justify-between gap-y-4 md:flex-row md:items-center md:gap-x-4 xl:gap-x-5">
            <strong className="text-h6 md:w-[180px] md:shrink-0">{t('Services in store')}:</strong>
            {availableServices.hasLoyaltyProgram && (
                <StoreServiceCheckbox
                    checked={serviceFilters.hasLoyaltyProgram}
                    icon={serviceIcons.hasLoyaltyProgramIcon}
                    id="store-service-loyalty-program"
                    label={t('TESCOMA Club')}
                    onChange={(isChecked) => onServiceFilterChange('hasLoyaltyProgram', isChecked)}
                />
            )}
            {availableServices.isPickupPoint && (
                <StoreServiceCheckbox
                    checked={serviceFilters.isPickupPoint}
                    icon={serviceIcons.isPickupPointIcon}
                    id="store-service-pickup-point"
                    label={t('E-shop reservation pickup')}
                    onChange={(isChecked) => onServiceFilterChange('isPickupPoint', isChecked)}
                />
            )}
            {availableServices.acceptGiftCoupon && (
                <StoreServiceCheckbox
                    checked={serviceFilters.acceptGiftCoupon}
                    icon={serviceIcons.acceptGiftCouponIcon}
                    id="store-service-gift-coupon"
                    label={t('Gift voucher redemption')}
                    onChange={(isChecked) => onServiceFilterChange('acceptGiftCoupon', isChecked)}
                />
            )}
        </div>
    );
};
